import { DateTimeField, TextField } from '@mi-front/ui';
import moment from 'moment-timezone';
import { useIntl } from 'react-intl';
import { useTimezone } from '@app/core/hooks/useTimezone';

export const SchedulesListMentionsForm = () => {
  const { $t } = useIntl();
  const tz = useTimezone();

  return (
    <div>
      <div className="row">
        <div className="col-4">
          <DateTimeField
            name="from"
            dateLabel={$t({
              id: 'common.dateStart',
              defaultMessage: 'Fecha inicio',
            })}
            timeLabel={$t({
              id: 'common.timeStart',
              defaultMessage: 'Hora inicio',
            })}
            isOutsideRange={(date) => moment(date) > moment()}
            tz={tz}
          />
        </div>
        <div className="col-4">
          <DateTimeField
            name="to"
            dateLabel={$t({
              id: 'common.dateEnd',
              defaultMessage: 'Fecha fin',
            })}
            timeLabel={$t({
              id: 'common.timeEnd',
              defaultMessage: 'Hora fin',
            })}
            isOutsideRange={(date) => moment(date) > moment()}
            tz={tz}
          />
        </div>
      </div>
      <div className="col-4 p-0">
        <TextField
          size="sm"
          name="customId"
          placeholder={$t({
            id: 'audit.schedulesListScreen.filter.idPlaceholder',
            defaultMessage: 'Filtrar por Archivo ID',
          })}
        />
      </div>
    </div>
  );
};
